//#region src/components/SnippetWithControls/SnippetWithControls.module.css
var e = "_controls_1dv0b_1", t = "_multiLineContainer_1dv0b_6", n = "_multiLine_1dv0b_6", r = "_singleLine_1dv0b_23", i = "_noScroll_1dv0b_33", a = "_small_1dv0b_51", o = "_large_1dv0b_56", s = "_secondary_1dv0b_62", c = "_singleLineValue_1dv0b_67", l = {
	controls: e,
	multiLineContainer: t,
	multiLine: n,
	singleLine: r,
	noScroll: i,
	small: a,
	large: o,
	secondary: s,
	singleLineValue: c
};
//#endregion
export { e as controls, l as default, o as large, n as multiLine, t as multiLineContainer, i as noScroll, s as secondary, r as singleLine, c as singleLineValue, a as small };
